<template>
	<div>
		<div class="d-flex flex-column m-2">
			<div class="astc-head">Test Name</div>
			<div class="mt-2 mb-3" style="width: 80%">
				<div
					class="d-inline-block testconfighead-auto mt-0 ellipsis"
					v-b-popover.hover.top="testData.name"
					style="max-width: 100%"
				>
					{{ testData.name }}
				</div>
			</div>
			<div class="astc-border-bottom"></div>

			<div class="d-flex justify-content-between mt-4">
				<div class="d-flex align-items-center mb-1">
					<img
						src="../../assets/icons/Reports/bckarrow.svg"
						alt=""
						class="pointer"
						v-if="showtestconfig"
						@click="showtestconfig = false"
					/>
					<span class="testconfighead-auto ml-2" v-if="showtestconfig"
						>Test Configuration</span
					>
					<span v-else class="normaltext">Tagged Groups and Individuals</span>
				</div>
			</div>

			<template v-if="!showtestconfig">
				<b-overlay
					:show="showSpinner"
					variant="white"
					:opacity="overlayOpacity"
					:blur="overlayBlur"
					rounded="sm"
					class="mt-2"
				>
					<template v-if="groups.length > 0">
						<div class="astc-left-container-overflow pt-2">
							<div
								v-for="group in groups"
								:key="group.groupID"
								class="mb-2 mr-1"
							>
								<div class="astc-group-container p-3">
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<div style="width: 70%" class="d-flex align-items-center">
											<span v-if="group.candidateType == 'I'"
												><img
													:id="'private-popover' + group.groupID"
													src="../../assets/icons/Reports/singlepep.svg"
													alt=""
											/></span>
											<span v-if="group.candidateType == 'G'"
												><img
													:id="'private-popover' + group.groupID"
													src="../../assets/icons/Reports/grouppeople.svg"
													alt=""
											/></span>
											<span v-if="group.candidateType == 'R'">
												<img
													:id="'private-popover' + group.groupID"
													src="../../assets/icons/share/recruitmentGroup.svg"
													alt=""
												/>
											</span>
											<b-popover
												:target="'private-popover' + group.groupID"
												triggers="hover"
												placement="top"
											>
												<div
													class="d-flex justify-content-center"
													:class="
														group.candidateType == 'R' ? 'swp-main-text' : ''
													"
												>
													{{
														group.candidateType == "I" ? "Individual" : "Group"
													}}
												</div>
												<div
													v-if="group.candidateType == 'R'"
													class="pr-tp-testhead"
												>
													Created from recruitment
												</div>
											</b-popover>

											<div class="ml-2 text-truncate">
												{{ group.groupName }}
											</div>
										</div>
										<div>
											<img
												v-if="
													!viewtag || group.groupID != selectedGroup.groupID
												"
												v-b-popover.hover.top="'Preview'"
												src="../../assets/preview eye.svg"
												alt=""
												class="mt-1 mb-1 ml-1 mr-2 pointer"
												@click="viewGroupInfo(group)"
												:class="
													!group.hasOwnProperty('configID') ? 'eye-margin' : ''
												"
											/>
											<img
												v-else
												v-b-popover.hover.top="'Close Preview'"
												src="../../assets/visibility_off.svg"
												alt=""
												class="mt-1 mb-1 ml-1 mr-2"
												:class="
													!group.hasOwnProperty('configID') ? 'eye-margin' : ''
												"
											/>
											<img
												v-show="group['configID']"
												src="../../assets/rightarrow.svg"
												alt=""
												class="pointer p-2"
												@click="group['configID'] ? getConfig(group) : ''"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="d-flex align-items-center justify-content-center pt-3 pointer"
							v-if="
								groups.length > 0 &&
									(roles.includes('GET_AUTO_INDIVIDUAL') ||
										roles.includes('GET_AUTO_GROUP'))
							"
							@click="testData.allSectionsHaveQuestions ? goToGroupShare() : ''"
							:disabled="!testData.allSectionsHaveQuestions"
						>
							<span
								:class="
									!testData.allSectionsHaveQuestions ? 'disabled-text' : ''
								"
								class="goToShareLink mt-0"
								v-b-tooltip.hover
								:title="
									!testData.allSectionsHaveQuestions
										? 'To Enable Add Questions To All Sections'
										: ''
								"
							>
								Go To Share Link Page
							</span>
							<img src="../../assets/rightarrow.svg" alt="" class="ml-2" />
						</div>
					</template>
					<template v-else>
						<div class="configpreviewgraph text-center">
							<img
								src="../../assets/icons/testconfig/noindividual.svg"
								alt=""
							/>
							<div
								v-if="
									roles.includes('GET_AUTO_INDIVIDUAL') ||
										roles.includes('GET_AUTO_GROUP')
								"
								:class="
									!testData.allSectionsHaveQuestions ? 'disabled-text' : ''
								"
								class="d-flex goToShareLink justify-content-center mt-3 pointer"
								@click="
									testData.allSectionsHaveQuestions ? goToGroupShare() : ''
								"
								:disabled="!testData.allSectionsHaveQuestions"
								v-b-tooltip.hover
								:title="
									!testData.allSectionsHaveQuestions
										? 'To Enable Add Questions To All Sections'
										: ''
								"
							>
								Go To Share Link Page
								<img
									src="../../assets/icons/testconfig/leftArrow.svg"
									alt=""
									class="ml-2"
								/>
							</div>
						</div>
					</template>
				</b-overlay>
			</template>
			<div v-if="showtestconfig" class="autotst-config-insidecontainer">
				<div class="testconfigs-container mt-0">
					<div
						class="d-flex justify-content-between align-items-center relativeclass mt-0 pointer"
						v-b-toggle.screendisplay
					>
						<span class="testconfig-btns mt-0" style="width: 90%">
							Opening Screen Display</span
						>
						<span
							v-if="roles.includes('PUT_AUTO_CONFIG')"
							@click.stop="openSelectedTab(0)"
							class="mr-3 pointer"
						>
							<img src="../../assets/pencilicon.svg" alt="" />
						</span>
						<span class="when-closed">
							<img src="../../assets/downarrow.svg" alt="" />
						</span>
						<span class="when-open">
							<img src="../../assets/uparrow.svg" alt="" />
						</span>
					</div>
				</div>
				<b-collapse
					id="screendisplay"
					accordion="my-accordion"
					role="tabpanel"
					class="screendisplay-content"
					visible
				>
					<b-card-body>
						<div>
							<div class="ts-sideconfg-heading">Config Name</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.configName }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Test Organiser</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.testOrg }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Test Description</div>
							<div
								class="ts-sideconfg-content"
								v-html-safe="testConfigData.config.testDesc"
							></div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">Test</div>
							<div class="ts-sideconfg-content">
								{{ configData.test }}
							</div>
						</div>
					</b-card-body>
				</b-collapse>
				<div class="testconfigs-container">
					<div
						class="d-flex justify-content-between align-items-center relativeclass pointer"
						v-b-toggle.questnbehaviour
					>
						<span class="testconfig-btns" style="width: 90%"
							>Questions Behaviour
						</span>
						<span
							v-if="roles.includes('PUT_AUTO_CONFIG')"
							@click.stop="openSelectedTab(1)"
							class="mr-3"
						>
							<img src="../../assets/pencilicon.svg" alt="" />
						</span>
						<span class="when-closed">
							<img src="../../assets/downarrow.svg" alt="" />
						</span>
						<span class="when-open">
							<img src="../../assets/uparrow.svg" alt="" />
						</span>
					</div>
				</div>
				<b-collapse
					id="questnbehaviour"
					accordion="my-accordion"
					role="tabpanel"
					class="screendisplay-content"
				>
					<b-card-body>
						<div>
							<div class="ts-sideconfg-heading">Test Duration (Minutes)</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.testDuration }}
							</div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">Start Test Date & Time</div>
							<div class="ts-sideconfg-content">
								{{ getITCDateTime(testConfigData.config.openTestdt) }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">End Test Date & Time</div>
							<div class="ts-sideconfg-content">
								{{ getITCDateTime(testConfigData.config.closeTestdt) }}
							</div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">
								Number Of Questions Per Screen
							</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.quesPerScreen }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Randomly Shuffle Questions</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.shuffle"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Maximum number Of Attempts</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.maxnoattempts }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Buffer Time (Minutes)</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.buffertime }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">
								Time between attempts (hours)
							</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.timebetweenattempts }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">
								Display Mandatory Questions Icon
							</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.dispReqStatus"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">
								Display Mandatory Questions First
							</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.displayReqFirst"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">
								Display Marks For Every Question
							</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.dispMarks"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">Specify Negative Marks</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.negativeMarkValue }}
							</div>
						</div>
						<hr />
					</b-card-body>
				</b-collapse>

				<div class="testconfigs-container">
					<div
						class="d-flex justify-content-between align-items-center relativeclass pointer"
						v-b-toggle.systemsetup
					>
						<span class="testconfig-btns" style="width: 90%">System Setup</span>
						<span
							v-if="roles.includes('PUT_AUTO_CONFIG')"
							@click.stop="openSelectedTab(2)"
							class="mr-3"
						>
							<img src="../../assets/pencilicon.svg" alt="" />
						</span>
						<span class="when-closed">
							<img src="../../assets/downarrow.svg" alt="" />
						</span>
						<span class="when-open">
							<img src="../../assets/uparrow.svg" alt="" />
						</span>
					</div>
				</div>
				<b-collapse
					id="systemsetup"
					accordion="my-accordion"
					role="tabpanel"
					class="screendisplay-content"
				>
					<b-card-body>
						<template v-if="testConfigData.config.enableProctoring">
							<div>
								<div class="ts-sideconfg-heading">
									Set Image Capture Timing-Slot (second)
								</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.screenCapture }}
								</div>
							</div>
							<hr />
						</template>

						<template v-if="testConfigData.config.communicationTest">
							<div>
								<div class="ts-sideconfg-heading">
									Communication Test Duration (Seconds)
								</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.communicationTestDuration }}
								</div>
							</div>
							<hr />
						</template>
						<div>
							<div class="ts-sideconfg-heading">Communication Test</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.communicationTest"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">Enable Proctoring</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.enableProctoring"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<template v-if="testConfigData.config.typingTest">
							<div>
								<div class="ts-sideconfg-heading">Typing Duration</div>
								<div class="ts-sideconfg-content">
									{{ testConfigData.config.typingDuration }}
								</div>
							</div>
							<hr />
						</template>

						<div>
							<div class="ts-sideconfg-heading">Typing Test</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.typingTest"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">Enable Video Recording</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.enableCamera"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">
								Include Time Sensitivity Notifications
							</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.includeTimeNotifics"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Enable Internet Check</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.internetCheck"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />

						<div>
							<div class="ts-sideconfg-heading">Allow Candidate Feedback</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.allowCandidateRemarks"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Allow Agent</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.allowAgent"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Passing Percentage</div>
							<div class="ts-sideconfg-content">
								{{ testConfigData.config.passingPercentage }}
							</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Allow Extension</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.allowExtension"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content">No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Allow Image and ID capture</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.allowImageAndIdCapture"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Instant Test Result</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.instantemail"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
						<hr />
						<div>
							<div class="ts-sideconfg-heading">Enable ScreenShare</div>
							<div
								class="ts-sideconfg-content"
								v-if="testConfigData.config.enableScreenShare"
							>
								Yes
							</div>
							<div class="ts-sideconfg-content" v-else>No</div>
						</div>
					</b-card-body>
				</b-collapse>

				<div class="testconfigs-container">
					<div
						class="d-flex justify-content-between align-items-center relativeclass pointer"
						v-b-toggle.dondonts
					>
						<span class="testconfig-btns" style="width: 90%"
							>Do’s and Dont’s</span
						>
						<span
							v-if="roles.includes('PUT_AUTO_CONFIG')"
							@click.stop="openSelectedTab(3)"
							class="mr-3"
						>
							<img src="../../assets/pencilicon.svg" alt="" />
						</span>
						<span class="when-closed">
							<img src="../../assets/downarrow.svg" alt="" />
						</span>
						<span class="when-open">
							<img src="../../assets/uparrow.svg" alt="" />
						</span>
					</div>
				</div>
				<b-collapse
					id="dondonts"
					accordion="my-accordion"
					role="tabpanel"
					class="screendisplay-content"
				>
					<b-card-body>
						<div>
							<div class="ts-sideconfg-heading">Do's and Dont's</div>
							<div
								v-for="(i, index) in testConfigData.config.dosAndDonts"
								:key="i.value"
								class="ts-sideconfg-content"
							>
								<span class="mt-3">{{ index + 1 }}</span
								>. {{ i.value }}
							</div>
						</div>
					</b-card-body>
				</b-collapse>
			</div>
		</div>
		<b-modal
			id="modal-1"
			class="testconfigmodal"
			centered
			hide-footer
			hide-header
			size="xl"
			no-close-on-backdrop
		>
			<div class="modalheading">Configure Test</div>
			<div @click="closeconfigmodal()" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 test-section-tabs">
				<b-tabs v-model="tabIndex" content-class="mt-3">
					<b-tab>
						<template #title>
							Opening Screen Display
							<template v-if="testinstruction == 'accepted'">
								<img
									v-if="
										dirtyCheckQuestion ||
											$v.testConfigData.config.testOrg.$error ||
											($v.testConfigData.config.testDesc.$error &&
												dirtyCheckDescQuestion) ||
											$v.configName.$error
									"
									src="../../assets/deletepopupicon.svg"
									alt=""
									v-b-popover.hover.top.v-danger="{
										content: 'Please fill all the details',
									}"
									variant="primary"
								/>
							</template>
							<template v-if="testinstruction == 'not_accepted'">
								<img
									v-if="
										dirtyCheckDescQuestion ||
											$v.testConfigData.config.testOrg.$error ||
											($v.testConfigData.config.testDesc.$error &&
												dirtyCheckDescQuestion) ||
											$v.configName.$error
									"
									src="../../assets/deletepopupicon.svg"
									alt=""
								/>
							</template>
						</template>

						<div class="astc-config-modal-overflow">
							<b-row>
								<b-col>
									<div class="testconfig-topDiv mt-3 position-relative">
										<label class="fieldsetStyle"
											>Configuration Name &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											type="text"
											placeholder="Enter here"
											v-model.trim="$v.configName.$model"
											:class="{
												error: $v.configName.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="$v.configName.$dirty && !$v.configName.required"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="!$v.configName.maxLength && $v.configName.required"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="testconfig-topDiv mt-3 relativeclass">
										<label class="fieldsetStyle"
											>Test Organiser &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											id="input-1"
											type="text"
											placeholder="Enter here"
											v-model.trim="$v.testConfigData.config.testOrg.$model"
											:class="{
												error: $v.testConfigData.config.testOrg.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.testOrg.$dirty &&
													!$v.testConfigData.config.testOrg.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.testOrg.maxLength &&
													$v.testConfigData.config.testOrg.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 128 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>

							<b-row>
								<b-col>
									<div class="topDiv mt-3 relativeclass">
										<div
											:class="
												dirtyCheckDescQuestion ||
												(!$v.testConfigData.config.testDesc.maxLength &&
													!dirtyCheckDescQuestion)
													? 'error'
													: ''
											"
										>
											<label class="testconfigfieldsetStyle" style="z-index: 5"
												>Test Description&nbsp;<span class="asterik"
													>*</span
												></label
											>

											<QuillEditor
												:addquesProp="addques1"
												:value="$v.testConfigData.config.testDesc.$model"
												@validationVal="validateText"
												@questionText="updateQuestionContent"
												@addquesBack="changedaddQues"
											>
											</QuillEditor>
										</div>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												dirtyCheckDescQuestion &&
													$v.testConfigData.config.testDesc.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												!$v.testConfigData.config.testDesc.maxLength &&
													!dirtyCheckDescQuestion
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should not exceed 10024 characters',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 5px; right: 12px"
											v-if="
												dirtyCheckDescQuestion &&
													!$v.testConfigData.config.testDesc.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<div class="d-flex mt-3">
										<span>Test</span>
										<b-form-radio-group
											class="ml-3"
											:options="testoptions"
											v-model="testConfigData.config.test"
											:disabled="selectedGroup.groupType == 'I'"
											value-field="item"
											text-field="name"
											disabled-field="notEnabled"
											size="sm"
											:id="
												selectedGroup.groupType == 'I' ? 'private-popover' : ''
											"
										></b-form-radio-group>
										<b-popover
											target="private-popover"
											triggers="hover"
											placement="top"
											custom-class="warning-box"
										>
											<img
												src="../../assets/icons/Qpbuilder/warning.svg"
												alt=""
											/>
											You cannot set a test as public for Individual Candidate
										</b-popover>
									</div>
								</b-col>
							</b-row>
						</div>
						<div class="d-flex justify-content-end mt-5 testconfig-saveproceed">
							<b-button @click="openscreeen()" class="addbtn ml-2"
								>Next</b-button
							>
						</div>
					</b-tab>

					<b-tab>
						<template #title>
							Question Behaviour
							<img
								v-if="
									$v.testConfigData.config.quesPerScreen.$error ||
										$v.testConfigData.config.passingPercentage.$error ||
										$v.testConfigData.config.negativeMarkValue.$error ||
										$v.testConfigData.config.buffertime.$error ||
										$v.testConfigData.config.timebnsel.$error ||
										$v.testConfigData.config.timebnvalue.$error ||
										$v.testConfigData.config.maxnoattempts.$error ||
										$v.testConfigData.config.testDuration.$error ||
										$v.testConfigData.config.openTestdt.$error ||
										$v.testConfigData.config.closeTestdt.$error
								"
								v-b-popover.hover.top.v-danger="{
									content: 'Please fill all the details',
								}"
								variant="primary"
								src="../../assets/deletepopupicon.svg"
								alt=""
							/>
						</template>
						<div class="astc-config-modal-overflow">
							<b-row>
								<b-col>
									<div class="testconfig-topDiv mt-4 relativeclass">
										<label class="fieldsetStyle"
											>Test Duration (Minutes)&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											id="input-1"
											placeholder="Enter duration in minutes"
											type="text"
											v-model="$v.testConfigData.config.testDuration.$model"
											@keypress="validateInput($event)"
											:class="{
												error: $v.testConfigData.config.testDuration.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.testDuration.$dirty &&
													!$v.testConfigData.config.testDuration.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.testDuration.alpha &&
													$v.testConfigData.config.testDuration.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid value',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.testDuration.between &&
													$v.testConfigData.config.testDuration.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 5 to 360',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>

								<b-col>
									<div class="testconfig-topDiv relativeclass mt-4">
										<label class="fieldsetStyle"
											>Passing Percentage&nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											placeholder="Enter here"
											class="inputField pr-35"
											id="input-1"
											type="text"
											v-model.trim="
												$v.testConfigData.config.passingPercentage.$model
											"
											@keypress="validateInput($event)"
											@keyup="changeconfig()"
											:class="{
												error:
													$v.testConfigData.config.passingPercentage.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.passingPercentage.$dirty &&
													!$v.testConfigData.config.passingPercentage.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.passingPercentage.numeric &&
													$v.testConfigData.config.passingPercentage.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.passingPercentage.between &&
													$v.testConfigData.config.passingPercentage.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 100',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>

							<b-row>
								<b-col>
									<div class="topDiv mt-3 relativeclass">
										<label class="fieldsetStyle"
											>Start Test Date & Time &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<datetime
											placeholder="Select Start date & time"
											ref="startDate"
											id="input-1"
											class="startdateconfig"
											type="datetime"
											:min-datetime="startdatetime"
											use12-hour
											v-model="testConfigData.config.openTestdt"
											:class="{
												error:
													$v.testConfigData.config.openTestdt.$error ||
													timeDiffMinutes,
											}"
										></datetime>
										<img
											@click="focusOnStartDate()"
											class="calender-image pointer"
											src="../../assets/calendar.svg"
											alt=""
										/>
									</div>
									<div
										style="position: absolute; top: 20px; right: 48px"
										v-if="
											$v.testConfigData.config.openTestdt.$dirty &&
												!$v.testConfigData.config.openTestdt.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</b-col>
								<b-col>
									<div class="topDiv mt-3 relativeclass">
										<label class="fieldsetStyle"
											>End Test Date & Time&nbsp;<span class="asterik">*</span>
										</label>

										<datetime
											ref="endDate"
											placeholder="Select End date & time"
											class="startdateconfig"
											type="datetime"
											id="input-1"
											use12-hour
											:min-datetime="minDate"
											v-model="testConfigData.config.closeTestdt"
											:class="{
												error:
													$v.testConfigData.config.closeTestdt.$error ||
													timeDiffMinutes,
											}"
										></datetime>
										<img
											@click="focusOnEndDate()"
											class="calender-image pointer"
											src="../../assets/calendar.svg"
											alt=""
										/>
									</div>
									<div
										style="position: absolute; top: 20px; right: 48px"
										v-if="
											$v.testConfigData.config.closeTestdt.$dirty &&
												!$v.testConfigData.config.closeTestdt.required
										"
										v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										variant="primary"
									>
										<img src="../../assets/deletepopupicon.svg" alt="" />
									</div>
								</b-col>
							</b-row>
							<div
								class="testtime-warning-box p-1 mt-1"
								style="width: 50%; margin-top: 10px; padding: 8px"
								v-if="timeDiffMinutes"
							>
								<img src="../../assets/testtimewarning.svg" alt="" />

								The start and end time & date cannot be less than the test
								duration.
							</div>

							<b-row>
								<b-col>
									<div class="testconfig-topDiv mt-3 position-relative">
										<label class="fieldsetStyle"
											>Number of questions per screen &nbsp;<span
												class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											type="text"
											placeholder="Enter here"
											v-model.trim="
												$v.testConfigData.config.quesPerScreen.$model
											"
											@keypress="validateInput($event)"
											:class="{
												error: $v.testConfigData.config.quesPerScreen.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.quesPerScreen.$dirty &&
													!$v.testConfigData.config.quesPerScreen.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.quesPerScreen.between &&
													$v.testConfigData.config.quesPerScreen.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 10',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.quesPerScreen.numeric &&
													$v.testConfigData.config.quesPerScreen.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Enter a valid value',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="testconfig-topDiv mt-3 relativeclass">
										<label class="fieldsetStyle"
											>Specify negative marks &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											id="input-1"
											type="text"
											placeholder="Enter here"
											v-model.trim="
												$v.testConfigData.config.negativeMarkValue.$model
											"
											@keypress="validateInput($event)"
											:class="{
												error:
													$v.testConfigData.config.negativeMarkValue.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.negativeMarkValue.$dirty &&
													!$v.testConfigData.config.negativeMarkValue.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.negativeMarkValue.numeric &&
													$v.testConfigData.config.negativeMarkValue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Not valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.negativeMarkValue.between &&
													$v.testConfigData.config.negativeMarkValue.numeric
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 0 to 30',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>

							<b-row>
								<b-col>
									<div class="testconfig-topDiv mt-3 position-relative">
										<label class="fieldsetStyle"
											>Maximum Number of Attempts &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											type="text"
											placeholder="Enter here"
											v-model.trim="
												$v.testConfigData.config.maxnoattempts.$model
											"
											@keypress="validateInput($event)"
											:class="{
												error: $v.testConfigData.config.maxnoattempts.$error,
											}"
										></b-form-input>
										<b-popover
											target="attempt"
											triggers="hover"
											placement="bottom"
											custom-class="attempt-warning-box"
										>
											<img
												src="../../assets/icons/Qpbuilder/warning.svg"
												alt=""
											/>
											As the start and end time & date duration is only
											applicable to a single attempt, you cannot select more
											than one maximum number of attempts.
										</b-popover>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.maxnoattempts.$dirty &&
													!$v.testConfigData.config.maxnoattempts.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.maxnoattempts.numeric &&
													$v.testConfigData.config.maxnoattempts.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Not valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.maxnoattempts.between &&
													$v.testConfigData.config.maxnoattempts.numeric
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 10',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col>
									<div class="testconfig-topDiv mt-3 relativeclass">
										<label class="fieldsetStyle"
											>Buffer Time (Minute) &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="inputField pr-35"
											id="input-1"
											type="text"
											placeholder="Enter here"
											v-model.trim="$v.testConfigData.config.buffertime.$model"
											@keypress="validateInput($event)"
											:class="{
												error: $v.testConfigData.config.buffertime.$error,
											}"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.buffertime.$dirty &&
													!$v.testConfigData.config.buffertime.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.buffertime.numeric &&
													$v.testConfigData.config.buffertime.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Not valid number',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												!$v.testConfigData.config.buffertime.between &&
													$v.testConfigData.config.buffertime.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 0 to 60',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</b-row>
							<b-row>
								<b-col>
									<label class="pt-testconfigfieldsetStyle sharelabel mt-2"
										>Time Between Attempts<span
											class="asterik"
											v-if="testConfigData.config.maxnoattempts > 1"
											>*</span
										></label
									>
								</b-col>
								<b-col>
									<label
										v-if="testConfigData.config.maxnoattempts > 1"
										class="pt-testconfigfieldsetStyle sharelabel mt-2"
										>Priority Attempt
									</label>
								</b-col>
							</b-row>

							<b-row>
								<b-col cols="2">
									<div class="position-relative mt-2">
										<div
											ref="timeBetweenAttemptsDropdown"
											class="ptc-dropdown-diffy d-flex justify-content-between pointer"
											@click="
												testConfigData.config.maxnoattempts < 2
													? ''
													: (timeattempts = !timeattempts)
											"
											:class="
												$v.testConfigData.config.timebnsel.$error ? 'error' : ''
											"
										>
											<span>{{
												testConfigData.config.timebnsel == "hrs"
													? "Hours"
													: testConfigData.config.timebnsel == "mins"
													? "Minutes"
													: testConfigData.config.timebnsel == "days"
													? "Days"
													: "Select"
											}}</span>

											<div>
												<img
													src="../../assets/downarrow.svg"
													class="pointer"
													alt=""
												/>
											</div>
										</div>
										<div
											v-closable="{
												exclude: ['timeBetweenAttemptsDropdown'],
												handler: 'hidetimeBetweenAttemptsDropdown',
											}"
											v-if="timeattempts"
											class="qb-dropdown-option-add d-flex p-0 w-100"
										>
											<b-form-group
												class="qb-dd-group"
												style="overflow-y: hidden"
											>
												<b-form-radio-group
													@change="timeattempts = !timeattempts"
													class="qb-add-drop w-100"
													id="btn-radios-3"
													v-model="$v.testConfigData.config.timebnsel.$model"
													:options="filteredTimeOptions"
													name="radio-btn-stacked"
													buttons
													stacked
												></b-form-radio-group>
											</b-form-group>
										</div>
										<div
											style="position: absolute; top: 5px; right: 25px"
											v-if="
												$v.testConfigData.config.timebnsel.$dirty &&
													!$v.testConfigData.config.timebnsel.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col cols="4">
									<div class="testconfig-topDiv mt-2 relativeclass">
										<b-form-input
											class="inputField pr-35"
											id="input-1"
											type="text"
											:placeholder="
												`${
													testConfigData.config.timebnsel == 'hrs'
														? 'Enter in hours'
														: testConfigData.config.timebnsel == 'mins'
														? 'Enter in minutes'
														: testConfigData.config.timebnsel == 'days'
														? 'Enter in days'
														: 'Enter time'
												}`
											"
											v-model="$v.testConfigData.config.timebnvalue.$model"
											@keypress="validateInput($event)"
											:class="
												$v.testConfigData.config.timebnvalue.$error
													? 'error'
													: ''
											"
										></b-form-input>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												$v.testConfigData.config.timebnvalue.$dirty &&
													!$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>

										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												testConfigData.config.timebnsel === 'hrs' &&
													!$v.testConfigData.config.timebnvalue.Validate &&
													$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 24',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												testConfigData.config.timebnsel === 'mins' &&
													!$v.testConfigData.config.timebnvalue.Validate &&
													$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be a whole number between 1 and 60.',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 2px; right: 12px"
											v-if="
												testConfigData.config.timebnsel === 'days' &&
													!$v.testConfigData.config.timebnvalue.Validate &&
													$v.testConfigData.config.timebnvalue.required
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Should be between 1 to 365',
											}"
											variant="primary"
										>
											<img src="../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col v-if="testConfigData.config.maxnoattempts > 1">
									<div class="d-flex align-items-center mt-2">
										<b-form-radio-group
											class="mcq-radiobtns radio-btn-label"
											:options="priorityoptions"
											v-model="testConfigData.config.priority"
											value-field="item"
											text-field="name"
											disabled-field="notEnabled"
											@change="changeconfig()"
											size="sm"
										></b-form-radio-group>
									</div>
								</b-col>
							</b-row>
							<b-row class="mt-3">
								<b-col cols="4">
									<div class="configpage-checkbox">
										<b-form-checkbox
											size="sm"
											class="mt-3"
											name="checkbox-1"
											v-model="testConfigData.config.shuffle"
										>
											Random/Shuffle Question
										</b-form-checkbox>
									</div>
								</b-col>
								<b-col cols="4">
									<div class="configpage-checkbox">
										<b-form-checkbox
											size="sm"
											class="mt-3"
											name="checkbox-1"
											v-model="testConfigData.config.dispReqStatus"
										>
											Display Mandatory Questions Icon
										</b-form-checkbox>
									</div>
								</b-col>
								<b-col> </b-col>
							</b-row>

							<b-row class="mt-3">
								<b-col cols="4">
									<div class="configpage-checkbox">
										<b-form-checkbox
											size="sm"
											class="mt-3"
											name="checkbox-1"
											v-model="testConfigData.config.displayReqFirst"
										>
											Display Mandatory Questions First
										</b-form-checkbox>
									</div>
								</b-col>
								<b-col cols="4">
									<div class="configpage-checkbox">
										<b-form-checkbox
											size="sm"
											class="mt-3"
											name="checkbox-1"
											v-model="testConfigData.config.dispMarks"
										>
											Display Marks for every Questions
										</b-form-checkbox>
									</div>
								</b-col>
								<b-col> </b-col>
							</b-row>
						</div>

						<div class="d-flex justify-content-end mt-5 testconfig-saveproceed">
							<b-button @click="questionbehaviour()" class="addbtn ml-2"
								>Next</b-button
							>
						</div>
					</b-tab>

					<b-tab>
						<template #title>
							System Setup
							<img
								v-if="
									$v.testConfigData.config.screenCapture.$error ||
										$v.testConfigData.config.communicationTestDuration.$error ||
										$v.testConfigData.config.communicationTestAttempts.$error ||
										(testConfigData.config.enableProctoring &&
											!testConfigData.config.enableCamera &&
											$v.testConfigData.config.passingPercentage.$dirty)
								"
								src="../../assets/deletepopupicon.svg"
								alt=""
								v-b-popover.hover.top.v-danger="{
									content: 'Please fill all the details',
								}"
								variant="primary"
							/>
						</template>
						<b-row class="astc-config-modal-overflow">
							<b-col cols="6">
								<div>
									<b-row>
										<b-col>
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													v-model="testConfigData.config.communicationTest"
													name="checkbox-1"
												>
													Communication Test
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="testconfig-topDiv mt-3 relativeclass">
												<label
													:class="
														testConfigData.config.communicationTest
															? 'fieldsetStyle'
															: 'testconfigfieldsetStyle'
													"
													>Communication Test Attempts &nbsp;<span
														class="asterik"
														>*</span
													></label
												>
												<b-form-input
													class="pr-35"
													id="input-1"
													placeholder="Enter here"
													type="text"
													v-model.trim="
														$v.testConfigData.config.communicationTestAttempts
															.$model
													"
													@keypress="validateInput($event)"
													:disabled="!testConfigData.config.communicationTest"
													:class="[
														testConfigData.config.communicationTest
															? 'inputField'
															: 'testconfiginputField',
														$v.testConfigData.config.communicationTestAttempts
															.$error
															? 'error'
															: '',
													]"
												></b-form-input>
												<div
													style="position: absolute; top: 2px; right: 12px"
													v-if="
														$v.testConfigData.config.communicationTestAttempts
															.$dirty &&
															!$v.testConfigData.config
																.communicationTestAttempts.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="position: absolute; top: 2px; right: 12px"
													v-if="
														!$v.testConfigData.config.communicationTestAttempts
															.numeric &&
															$v.testConfigData.config.communicationTestAttempts
																.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Not valid number',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="position: absolute; top: 2px; right: 12px"
													v-if="
														!$v.testConfigData.config.communicationTestAttempts
															.between &&
															$v.testConfigData.config.communicationTestAttempts
																.numeric
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Should be between 1 to 5',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													v-model="testConfigData.config.enableProctoring"
													name="checkbox-1"
												>
													Enable Video Proctoring
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col>
											<div class="testconfig-topDiv mt-3 relativeclass">
												<label
													:class="
														testConfigData.config.communicationTest
															? 'fieldsetStyle'
															: 'testconfigfieldsetStyle'
													"
													>Set Image Capture Timing-Slot (Seconds) &nbsp;<span
														class="asterik"
														>*</span
													></label
												>
												<b-form-input
													class="pr-35"
													id="input-1"
													:disabled="!testConfigData.config.enableProctoring"
													placeholder="Enter here"
													type="text"
													v-model.trim="
														$v.testConfigData.config.screenCapture.$model
													"
													@keypress="validateInput($event)"
													:class="[
														testConfigData.config.enableProctoring
															? 'inputField'
															: 'testconfiginputField',
														$v.testConfigData.config.screenCapture.$error
															? 'error'
															: '',
													]"
												></b-form-input>

												<div
													style="position: absolute; top: 2px; right: 12px"
													v-if="
														$v.testConfigData.config.screenCapture.$dirty &&
															!$v.testConfigData.config.screenCapture.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="position: absolute; top: 2px; right: 12px"
													v-if="
														!$v.testConfigData.config.screenCapture.numeric &&
															$v.testConfigData.config.screenCapture.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Accepts only 2 digit after decimal point',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="position: absolute; top: 2px; right: 12px"
													v-if="
														!$v.testConfigData.config.screenCapture.between &&
															$v.testConfigData.config.screenCapture.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Should be between 1 to 15',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
											</div>
										</b-col>
									</b-row>

									<b-row>
										<b-col>
											<div class="topDiv mt-3 relativeclass d-flex">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													name="checkbox-1"
													v-model="testConfigData.config.enableCamera"
													@change="
														selectdosanddonts(
															testConfigData.config.enableCamera,
															'enableCamera'
														)
													"
												>
													Enable Video Proctoring
												</b-form-checkbox>
												<img
													v-if="
														testConfigData.config.enableProctoring &&
															!testConfigData.config.enableCamera
													"
													src="../../assets/deletepopupicon.svg"
													alt=""
													class="mt-3 ml-1"
													v-b-popover.hover.top.v-danger="{
														content:
															'Enable Video Proctoring since proctoring is enabled',
													}"
												/>
											</div>
										</b-col>
									</b-row>
								</div>
							</b-col>
							<b-col>
								<div>
									<b-row>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													v-model="testConfigData.config.allowImageAndIdCapture"
													name="checkbox-1"
													@change="
														selectdosanddonts(
															testConfigData.config.allowImageAndIdCapture,
															'allowImageAndIdCapture'
														)
													"
												>
													Allow Image And ID Capture
												</b-form-checkbox>
											</div>
										</b-col>

										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													name="checkbox-1"
													v-model="testConfigData.config.typingTest"
												>
													Typing Test
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>

									<b-row>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													name="checkbox-1"
													v-model="testConfigData.config.instantemail"
													@change="
														selectdosanddonts(
															testConfigData.config.instantemail,
															'instantemail'
														)
													"
													>Instant Test Result
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													v-model="testConfigData.config.allowAgent"
													name="checkbox-1"
													@change="
														selectdosanddonts(
															testConfigData.config.allowAgent,
															'allowAgent'
														)
													"
													>Allow Agent
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>
									<b-row>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													name="checkbox-1"
													v-model="testConfigData.config.allowCandidateRemarks"
												>
													Allow Candidate Feedback
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													v-model="testConfigData.config.enableScreenShare"
													size="sm"
													name="checkbox-1"
												>
													Enable Screen Share
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>

									<b-row>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													v-model="testConfigData.config.includeTimeNotifics"
													name="checkbox-1"
												>
													Include Time Sensitivity Notifications
												</b-form-checkbox>
											</div>
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													size="sm"
													v-model="testConfigData.config.internetCheck"
													name="checkbox-1"
												>
													Enable Internet Check
												</b-form-checkbox>
											</div>
										</b-col>
										<b-col cols="6">
											<div class="topDiv mt-3 relativeclass">
												<b-form-checkbox
													class="mt-3 testconfig-checkbox"
													v-model="testConfigData.config.allowExtension"
													size="sm"
													name="checkbox-1"
													@change="
														selectdosanddonts(
															testConfigData.config.allowExtension,
															'allowExtension'
														)
													"
												>
													Allow Extension
												</b-form-checkbox>
											</div>
										</b-col>
									</b-row>

									<b-row> </b-row>
								</div>
							</b-col>
						</b-row>

						<div
							class="d-flex justify-content-start mt-5 testconfig-saveproceed"
						>
							<b-button @click="systemsetup()" class="addbtn ml-2"
								>Next</b-button
							>
						</div>
					</b-tab>
					<b-tab>
						<template #title>
							Do’s and Dont’s
							<img
								v-if="$v.testConfigData.config.dosAndDonts.$error"
								src="../../assets/deletepopupicon.svg"
								alt=""
								v-b-popover.hover.top.v-danger="{
									content: 'Please fill all the details',
								}"
								variant="primary"
							/>
						</template>
						<div class="base">
							<div class="testconfig-basediv">
								<draggable
									tag="div"
									group="trueexpdata"
									:list="testConfigData.config.dosAndDonts"
									class="pointer"
								>
									<div
										v-for="(i, index) in testConfigData.config.dosAndDonts"
										:key="i.value"
										class="mt-3"
									>
										<b-input-group>
											<div class="d-flex body-viewtrue-col">
												<div class="body-viewtrue-col testconfig-topDiv">
													<label class="fieldsetStyle"
														>{{ index + 1 }}. Do's & Dont’s &nbsp;<span
															class="asterik"
															>*</span
														></label
													>
													<b-form-input
														autofocus
														class="inputField pointer"
														id="input-1"
														placeholder="Enter here"
														v-model.trim="
															$v.testConfigData.config.dosAndDonts.$each[index]
																.value.$model
														"
														:class="{
															error:
																$v.testConfigData.config.dosAndDonts.$each[
																	index
																].value.$error,
														}"
														type="text"
														@keyup.enter="addOptions"
													></b-form-input>
												</div>
												<div
													style="position: absolute; top: 2px; right: 3vw"
													v-if="
														$v.testConfigData.config.dosAndDonts.$each[index]
															.value.$dirty &&
															!$v.testConfigData.config.dosAndDonts.$each[index]
																.value.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Required',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													style="position: absolute; top: 2px; right: 3vw"
													v-if="
														!$v.testConfigData.config.dosAndDonts.$each[index]
															.value.maxLength &&
															$v.testConfigData.config.dosAndDonts.$each[index]
																.value.required
													"
													v-b-popover.hover.top.v-danger="{
														content: 'Should not exceed 512 characters',
													}"
													variant="primary"
												>
													<img src="../../assets/deletepopupicon.svg" alt="" />
												</div>
												<div
													class="test-config-dodont-del"
													v-if="testConfigData.config.dosAndDonts.length > 1"
												>
													<b-button
														variant="outline"
														@click="deleteOption(index)"
													>
														<span
															><img src="../../assets/graydelete.svg" alt=""
														/></span>
													</b-button>
												</div>
											</div>
										</b-input-group>
									</div>
								</draggable>
							</div>
							<div v-if="errorstatus" class="text-center">
								<span class="asterik"
									>*please fill mandatory fields in all tabs</span
								>
							</div>
							<b-row class="">
								<b-col
									cols=""
									style="right: 0"
									class="testconfig-saveproceed d-flex align-items-center justify-content-end"
								>
									<div class="mr-3">
										<b-button
											@click="addOptions()"
											variant="outline"
											class="cursor-pointer p-2"
										>
											<span
												><img src="../../assets/addicongraywhite.svg" alt=""
											/></span>
											<span class="ml-2 dosdont-addtxt">Add</span>
										</b-button>
									</div>
									<b-button @click="saveConfig()" class="addbtn"
										>Update & Proceed</b-button
									>
								</b-col>
							</b-row>
						</div>
					</b-tab>
				</b-tabs>
			</div>
		</b-modal>
		<b-modal
			id="confirm-edit"
			centered
			hide-footer
			hide-header
			class="qb-add-ques-modal"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution !
				<img class="pr-3" src="../../assets/caution.svg" alt="" />
			</div>
			<div @click="$bvModal.hide('confirm-edit')" class="xMarkCancel">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 caution-modal-text">
				<span>Are you sure you want to edit ?</span>
			</div>
			<div class="mt-2 caution-modal-text">
				This configuration is tagged to more than one group. Do you want to
				create a new configuration or confirm the action?
			</div>
			<div class="mt-2 normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="addConfig()">Create New</b-button>
				<div @click="confirm()" class="sec-canceltext-active ml-2 pointer">
					Confirm
				</div>
			</div>
		</b-modal>
		<b-modal
			id="viewgroup"
			centered
			hide-footer
			hide-header
			class="shareview-modal"
			:no-close-on-backdrop="true"
		>
			<div class="modalheading ml-3 mt-1">
				<span>View </span>
				<span
					v-if="
						selectedGroup.candidateType == 'G' ||
							selectedGroup.candidateType == 'R'
					"
					>Group</span
				>
				<span v-else> Individual </span>
			</div>
			<hr />
			<div
				@click="$bvModal.hide('viewgroup'), (viewtag = false)"
				class="xMarkCancel"
			>
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="stc-view-grp-overflow">
				<div
					class="statstext ml-3 mt-2"
					v-if="
						selectedGroup.candidateType == 'G' ||
							selectedGroup.candidateType == 'R'
					"
				>
					{{ selectedGroup.groupName }}
				</div>
				<div class="statstext d-flex ml-3 mt-2 mb-3" v-else>
					<img
						src="../../assets/icons/Reports/singlepep.svg"
						alt=""
						class="mr-2"
					/>
					{{ selectedGroup.groupName }}
				</div>

				<div
					class="stc-view-grp-model-cards m-2"
					v-if="
						selectedGroup.candidateType == 'G' ||
							selectedGroup.candidateType == 'R'
					"
				>
					<div
						class="d-flex justify-content-between shareview-details pl-2 pr-2 pb-3 pt-3 mt-3"
					>
						<div class="d-flex flex-column ml-2">
							<span class="shareview-details-text">Group Candidates</span>
							<span class="shareview-details-bold">{{
								selectedGroup.candidates.length
							}}</span>
						</div>
						<div class="d-flex flex-column mr-2">
							<span class="shareview-details-text">Created On</span>
							<span class="shareview-details-bold">{{
								selectedGroup.createdAt | datefilter
							}}</span>
						</div>
					</div>
					<div class="mt-3 p-3 stc-share-viewgroup-container mr-2">
						<div
							class="mb-3"
							v-for="candidate in selectedGroup.candidates"
							:key="candidate"
						>
							<div class="d-flex justify-content-between">
								<div class="d-flex justify-content-between">
									<span
										><img
											src="../../assets/icons/Reports/singlepep.svg"
											alt=""
											class="mr-2"
									/></span>
									<div class="shareview-details-email mt-1">
										{{ candidate }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="stc-view-grp-model-cards-2 m-2 p-2">
					<label class="pr-tp-testhead ml-3">Configuration Name</label>
					<div
						class="shareview-details d-flex justify-content-between p-3 mb-3"
					>
						<div
							class="shareview-details-bold mt-0"
							v-if="selectedGroup['configID'] == undefined"
						>
							--
						</div>
						<div class="shareview-details-bold mt-0" v-else>
							{{ selectedGroup.configName }}
						</div>
						<div
							class="deliveredtext mt-0"
							v-if="selectedGroup['configID'] == undefined"
						>
							Not Configured
						</div>

						<span v-else-if="selectedGroup.open == 'False'" class="expiredClass"
							>Expired</span
						>
						<div
							class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center"
							v-else-if="selectedGroup.open == 'True'"
						>
							Active
						</div>
						<span
							v-else
							class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center"
							>Active</span
						>
					</div>
					<label class="pr-tp-testhead ml-3">Test Link</label>
					<div
						class="shareview-details d-flex justify-content-between align-items-center p-3 mb-3"
					>
						<div
							class="shareview-details-bold"
							v-if="selectedGroup['shareLink'] == undefined"
						>
							--
						</div>
						<div class="shareview-details-bold sharelink-break" v-else>
							{{ selectedGroup.shareLink }}
						</div>
						<div
							class="deliveredtext"
							v-if="selectedGroup['shareLink'] == undefined"
						>
							No Link Generated
						</div>
						<span
							v-else
							class="swp-active-btn swp-active-btn-text d-flex align-items-center justify-content-center"
							>Active</span
						>
					</div>
				</div>
				<div class="stc-view-grp-model-cards-3 m-2 p-3">
					<div class="d-flex justify-content-between align-items-center mb-1">
						<div class="test-config-head">
							<img src="../../assets/greenEvaluator.svg" alt="" />
							Evaluators
						</div>
						<div class="stc-light-text pr-2">
							Total Evaluators:
							<strong>{{ selectedGroup.evaluator.length }}</strong>
						</div>
					</div>
					<div class="stc-model-eval-overflow mr-2">
						<div
							class="d-flex align-items-center ml-1 mt-3"
							style="width: 90%"
							v-for="(evaluator, ind) in selectedGroup.evaluator"
							:key="ind"
						>
							<span
								><img
									src="../../assets/icons/Reports/singlepep.svg"
									alt=""
									class="mr-2"
							/></span>
							<div class="shareview-details-bold text-truncate">
								{{ evaluator.name }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script>
import QuillEditor from "../../components/forms/quillEditor.vue"; //Quill editor from component

import {
	required,
	maxLength,
	helpers,
	between,
	requiredIf,
	numeric,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import toastFunction from "../mixin/toast";
import {
	dosanddontslist,
	postTaggedGroup,
	getConfig,
	editConfig,
	addConfig,
} from "../../utils/apiFunctions";
import draggable from "vuedraggable";
import { DateTime as LuxonDateTime } from "luxon";

export default {
	components: {
		draggable,
		QuillEditor,
	},
	name: "SideTestConfig",
	mixins: [toastFunction],
	data() {
		return {
			globalWorks: false,
			addques1: false,
			addques2: false,
			dirtyCheckQuestion: false,
			dirtyCheckDescQuestion: false,
			startdatetime: LuxonDateTime.local()
				.minus({ month: 0, days: 0 })
				.toISO(),
			configData: {},
			viewtag: false,
			showSpinner: false,
			overlayOpacity: 0.46,
			overlayBlur: "4",
			configName: "",

			testinstruction: "not_accepted",
			tabIndex: 0,
			editablename: false,
			errorstatus: false,
			showtestconfig: false,

			groups: [],
			timeoptions: [
				{
					value: "mins",
					text: "Minutes",
				},
				{
					value: "hrs",
					text: "Hours",
				},
				{
					value: "days",
					text: "Days",
				},
			],
			testoptions: [
				{
					item: "public",
					name: "Public",
				},
				{
					item: "private",
					name: "Private",
				},
			],
			priorityoptions: [
				{
					item: "first",
					name: "First Attempt",
				},
				{
					item: "last",
					name: "Last Attempt",
				},
				{
					item: "highestScored",
					name: "Highest Scored",
				},
			],
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
			startDate: null,
			enDate: null,
			check: true,
			editorConfig: {
				toolbar: ["Bold", "Italic", "-", "NumberedList", "BulletedList", "-"],
			},
			timeattempts: false,

			testConfigData: {
				config: {
					testOrg: "",
					testDesc: "",
					testInst: "",
					timebnsel: "",
					timebnvalue: "",
					dispDuration: true,
					dispCount: true,
					allowCandidateRemarks: false,
					quesPerScreen: "10",
					priority: "first",
					shuffle: false,
					dispReqStatus: false,
					displayReqFirst: false,
					dispMarks: false,
					test: "public",
					allowAgent: false,
					payment: false,
					allowImageAndIdCapture: false,
					allowExtension: false,
					enableScreenShare: false,
					negativeMarkValue: null,
					openTestdt: null,
					closeTestdt: null,
					passingPercentage: null,
					testDuration: 30,
					typingTest: false,
					enableProctoring: false,
					communicationTest: false,
					communicationTestDuration: 45,
					communicationTestAttempts: null,

					typingDuration: 60,
					includeTimeNotific: false,
					enableCamera: false,
					includeEndTest: true,
					instantemail: false,
					internetCheck: false,
					maxnoattempts: 1,
					buffertime: null,
					timebetweenattempts: null,
					screenCapture: 0,
					paymentDetails: {
						cost: null,
						certificate: false,
						training: false,
						badge: false,
						toLearn: "",
						skillsGain: "",
						about: "",
					},
					dosAndDonts: [
						{
							value: "",
						},
					],
				},
			},
			selectedGroup: {
				groupName: "",
				createdAt: "",
				candidates: [],
				evaluator: [],
				groupID: "",
			},
		};
	},
	watch: {
		testData(newValue, oldValue) {
			if (newValue != oldValue) {
				this.getdosanddonts();
				this.getGroups(this.testData.testID);
			}
		},
	},
	computed: {
		timeDiffMinutes() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.testConfigData.config.testDuration !== null) {
					return (
						this.testConfigData.config.testDuration >
						Math.floor(timeDiff / (1000 * 60))
					);
				}
				return false;
			}
			return null;
		},


		hoursDiffAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiff = endDate.getTime() - startDate.getTime();

				if (this.testConfigData.config.testDuration !== null) {
					const hoursDiff = timeDiff / (1000 * 60 * 60);
					return hoursDiff > 24;
				}
				return false;
			}

			return null;
		},
		minutesDiffAttempts() {
			if (
				this.testConfigData.config.openTestdt &&
				this.testConfigData.config.closeTestdt
			) {
				const startDate = new Date(this.testConfigData.config.openTestdt);
				const endDate = new Date(this.testConfigData.config.closeTestdt);
				const timeDiffInMilliseconds = endDate.getTime() - startDate.getTime();
				const timeDiffInHours = timeDiffInMilliseconds / (1000 * 60 * 60);

				if (this.testConfigData.config.testDuration !== null) {
					return timeDiffInHours > 1;
				}
				return false;
			}

			return null;
		},
		filteredTimeOptions() {
			const showHours = this.minutesDiffAttempts;
			const showDays = this.hoursDiffAttempts;
			return this.timeoptions.filter(
				(option) =>
					(option.value !== "hrs" || showHours) &&
					(option.value !== "days" || showDays)
			);
		},
		currentDate: {
			// getter
			get: function() {
				if (
					this.testConfigData.config.closeTestdt <
					this.testConfigData.config.openTestdt
				) {
					return this.testConfigData.config.openTestdt;
				}
				return this.testConfigData.config.closeTestdt;
			},
			// setter
			set: function(newValue) {
				this.testConfigData.config.closeTestdt = newValue;
			},
		},
		minDate() {
			return this.testConfigData.config.openTestdt;
		},
		...mapGetters("autotestVUEX", {
			testData: "getTestConfigData",
		}),
		...mapGetters(["roles"]),
	},
	validations() {
		return {
			configName: {
				required,
				maxLength: maxLength(128),
			},
			testConfigData: {
				name: {
					required,
					maxLength: maxLength(128),
				},
				config: {
					testOrg: {
						required,
						maxLength: maxLength(128),
					},
					testDesc: {
						required,
						maxLength: maxLength(10024),
					},
					testInst: {
						required: requiredIf(function() {
							return this.testinstruction != "not_accepted";
						}),
						maxLength: maxLength(10024),
					},
					quesPerScreen: {
						required,
						between: between(1, 10),
						numeric,
					},
					negativeMarkValue: {
						required,
						between: between(0, 30),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					passingPercentage: {
						required,
						between: between(1, 100),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					testDuration: {
						required,
						between: between(5, 360),
						alpha: helpers.regex("alpha", /^\d{1,3}\.?\d{0,2}$/i),
					},

					openTestdt: {
						required,
					},
					closeTestdt: {
						required,
					},
					dosAndDonts: {
						$each: {
							value: {
								required,
								maxLength: maxLength(256),
							},
						},
					},
					paymentDetails: {
						cost: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
						about: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
						skillsGain: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
						toLearn: {
							required: requiredIf(function() {
								return this.testConfigData.config.payment;
							}),
						},
					},
					maxnoattempts: {
						required,
						numeric,
						between: between(1, 10),
					},
					buffertime: {
						required,

						between: between(0, 60),
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					timebnvalue: {
						required: requiredIf(function() {
							return (
								this.testConfigData.config.maxnoattempts >= 2 &&
								this.testConfigData.config.timebnsel != ""
							);
						}),
						Validate: this.validateTime,
						numeric: helpers.regex("numeric", /^\d{1,3}\.?\d{0,2}$/),
					},
					timebnsel: {
						required: requiredIf(function() {
							return this.testConfigData.config.maxnoattempts >= 2;
						}),
					},

					screenCapture: {
						required: requiredIf(function() {
							return this.testConfigData.config.enableProctoring;
						}),
						numeric,
						between: between(1, 15),
					},

					communicationTestDuration: {
						required: requiredIf(function() {
							return this.testConfigData.config.communicationTest;
						}),
						between: between(30, 360),
					},
					communicationTestAttempts: {
						required: requiredIf(function() {
							return this.testConfigData.config.communicationTest;
						}),
						between: between(1, 5),
						numeric,
					},
				},
			},
		};
	},
	created() {
		this.getdosanddonts();
		this.getGroups(this.testData.testID);
	},

	methods: {
		validateText(val) {
			this.dirtyCheckDescQuestion = val;
		},
		updateQuestionContent(newContent) {
			this.testConfigData.config.testDesc = newContent;
		},
		changedaddQues(newval) {
			this.addques1 = newval;
		},

		validateText2(val) {
			this.dirtyCheckQuestion = val;
		},
		updateQuestionContent2(newContent) {
			this.testConfigData.config.testInst = newContent;
		},
		changedaddQues2(newval) {
			this.addques2 = newval;
		},
		validateInput(event) {
			const charCode = event.keyCode || event.which;
			const charTyped = String.fromCharCode(charCode);
			// Regular expression to allow only numbers and a single dot
			const regex = /^(?!0{2,})\d{1,3}(?:\.\d{0,2})?$/;
			// If the typed character is not a number or dot, prevent the default behavior
			if (!regex.test(event.target.value + charTyped)) {
				event.preventDefault();
			}
		},
		getDesiredContent(contentType) {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML =
				contentType === "testDesc" ? this.testConfigData.config.testDesc : "";
			const pTags = tempDiv.querySelectorAll("p");

			let endIndex = pTags.length;

			for (let i = pTags.length - 1; i >= 0; i--) {
				if (this.isBetweenContentTag(pTags[i])) {
					endIndex = i + 1;
					break;
				}
			}

			pTags.forEach((pTag, index) => {
				if (index >= endIndex && !pTag.textContent.trim()) {
					tempDiv.removeChild(pTag);
				}
			});

			if (contentType === "testDesc") {
				this.testConfigData.config.testDesc = tempDiv.innerHTML;
			} else if (contentType === "testInst") {
				this.testConfigData.config.testInst = tempDiv.innerHTML;
			}
		},

		isBetweenContentTag(element) {
			return element.textContent.trim() !== "";
		},

		validateTime() {
			if (this.testConfigData.config.maxnoattempts > 1) {
				if (
					this.testConfigData.config.timebnsel === "hrs" &&
					this.testConfigData.config.timebnvalue > 0 &&
					this.testConfigData.config.timebnvalue <= 24
				) {
					return true;
				} else if (
					this.testConfigData.config.timebnsel === "mins" &&
					this.testConfigData.config.timebnvalue >= 1 &&
					this.testConfigData.config.timebnvalue <= 60 && 
					this.testConfigData.config.timebnvalue % 1 === 0
				) {
					return true;
				} else if (
					this.testConfigData.config.timebnsel === "days" &&
					this.testConfigData.config.timebnvalue >= 1 &&
					this.testConfigData.config.timebnvalue <= 365
				) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		},
		hidetimeBetweenAttemptsDropdown() {
			this.timeattempts = false;
		},
		async getGroups(testID) {
			this.showSpinner = true;
			try {
				let data = {
					tag: "1",
					page: 0,
					count: "all",
					testID: testID,
				};
				const res = await postTaggedGroup(data);
				if (res.status == 200) {
					this.groups = res.data.data.data;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
			this.showSpinner = false;
		},
		async getConfig(data) {
			try {
				this.showtestconfig = true;
				const res = await getConfig(data.configID);
				this.testConfigData = res.data.data;
				this.configData = { ...res.data.data.config };
				this.configName = res.data.data.configName;
				if (this.testConfigData.config.testInst.length > 0)
					this.testinstruction = "accepted";
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		async getdosanddonts() {
			try {
				const res = await dosanddontslist();
				if (res.status == 200) {
					let data = res.data.data;
					for (let i in data) {
						if (data[i].type == "Dos and Donts") {
							this.defaultdosanddonts = data[i].codeList;
						}
					}
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},

		// HELPER FUNCTION FOR CLEARING THE SELECTED GROUP
		clearSelectedGroup() {
			this.selectedGroup = {
				groupName: "",
				createdAt: "",
				candidates: [],
				evaluator: [],
				groupID: "",
			};
			this.showtestconfig = false;
		},

		// HELPER FUNCTION FOR UTC TO IST CONVERSION
		getITCDateTime(utcDateTime) {
			const utcDate = new Date(utcDateTime);
			const options = {
				timeZone: "Asia/Kolkata",
				day: "2-digit",
				month: "2-digit",
				year: "numeric",
				hour: "2-digit",
				minute: "2-digit",
			};
			const itcDate = utcDate
				.toLocaleString("en-IN", options)
				.replace(/\//g, "-");
			return itcDate;
		},
		closeViewGroup() {
			// this.clearSelectedGroup();
			this.$bvModal.hide("viewgroup");
		},
		selectdosanddonts(value, id) {
			if (value) {
				if (
					this.testConfigData.config.dosAndDonts.length > 0 &&
					this.testConfigData.config.dosAndDonts[0].value == ""
				) {
					this.testConfigData.config.dosAndDonts.splice(0, 1);
				}

				const defaultDosAndDonts = this.defaultdosanddonts.filter(
					(item) => item.value === id
				);
				defaultDosAndDonts.forEach((item) => {
					this.testConfigData.config.dosAndDonts.push({
						value: item.description,
						code: item.value,
					});
				});
			} else {
				const filteredDosAndDonts = this.testConfigData.config.dosAndDonts.filter(
					(item) => item.code !== id
				);
				this.testConfigData.config.dosAndDonts =
					filteredDosAndDonts.length > 0
						? filteredDosAndDonts
						: [{ value: "", code: "" }];
			}
		},
		viewGroupInfo(data) {
			this.viewtag = !this.viewtag;
			this.selectedGroup = data;
			this.$bvModal.show("viewgroup");
		},
		focusOnStartDate() {
			this.$refs.startDate.$el.children[0].click();
		},
		focusOnEndDate() {
			this.$refs.endDate.$el.children[0].click();
		},

		openSelectedTab(data) {
			this.tabIndex = data;
			this.$v.$reset();
			this.$bvModal.show("modal-1");
		},
		closeconfigmodal() {
			this.dirtyCheckDescQuestion = false;
			this.dirtyCheckQuestion = false;
			this.$bvModal.hide("modal-1");
			this.$v.$reset();
			let payload = {
				configID: this.testConfigData.configID,
			};
			this.getConfig(payload);
		},
		addOptions() {
			this.testConfigData.config.dosAndDonts.push({
				value: "",
			});
		},
		deleteOption(i) {
			this.testConfigData.config.dosAndDonts.splice(i, 1);
		},
		async saveConfig() {
			try {
				this.saveconfigvalid();
				if (
					this.globalWorks &&
					!this.$v.testConfigData.config.$invalid &&
					!this.dirtyCheckDescQuestion &&
					!(
						this.testConfigData.config.enableProctoring &&
						!this.testConfigData.config.enableCamera
					)
				) {
					this.getDesiredContent("testDesc");

					this.saveconfigapi();
					this.errorstatus = false;
				} else {
					this.errorstatus = true;
					if (this.testinstruction == "not_accepted") {
						this.dirtyCheckQuestion = false;
						if (
							this.$v.testConfigData.config.testDesc.$invalid ||
							this.dirtyCheckDescQuestion
						) {
							this.dirtyCheckDescQuestion = true;
						}
					}
				}
			} catch (error) {
				if (error.response.status == 409) {
					this.$bvModal.show("confirm-edit");
				} else {
					this.errorToast(error.response.data.data.Data);
				}
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		saveconfigvalid() {
			if (!this.testConfigData.config.dispCount) {
				this.testConfigData.config.dispCount = true;
			}
			if (!this.testConfigData.config.dispDuration) {
				this.testConfigData.config.dispDuration = true;
			}
			if (!this.testConfigData.config.includeEndTest) {
				this.testConfigData.config.includeEndTest = true;
			}
			this.$v.$touch();
			if (this.testinstruction == "not_accepted") {
				this.globalWorks = true;
			}
		},
		async saveconfigapi() {
			if (
				this.testConfigData.config.timebnsel != "" &&
				this.testConfigData.config.timebnsel != null
			) {
				if (this.testConfigData.config.timebnsel == "hrs") {
					this.testConfigData.config.timebetweenattempts =
						this.testConfigData.config.timebnvalue * 60;
				} else if (this.testConfigData.config.timebnsel == "days") {
					this.testConfigData.config.timebetweenattempts =
						this.testConfigData.config.timebnvalue * 1440;
				} else {
					this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebnvalue;
				}
			}
			let payload = {
				configID: this.testConfigData.configID,
				config: this.testConfigData.config,
				name: this.configName,
				check: this.check,
			};
			console.log(this.testConfigData, "testConfigData");

			const res = await editConfig(payload);

			if (res.status == 200) {
				this.$nextTick(() => {
					this.successToast("Configuration updated successfully");
				});
				this.addques1 = true;
				this.addques2 = true;
				this.dirtyCheckDescQuestion = false;
				this.dirtyCheckQuestion = false;
				let configId = {
					configID: this.testConfigData.configID,
				};
				this.getConfig(configId);
				this.check = true;
				this.$bvModal.hide("modal-1");
			} else if (res.status == 409) {
				this.$bvModal.show("confirm-edit");
			}
		},

		// Other supporting methods...

		async addConfig() {
			this.$v.testConfigData.config.$touch();
			this.$v.configName.$touch();

			try {
				if (
					!this.$v.testConfigData.config.$invalid &&
					!this.$v.configName.$invalid
				) {
					this.errorstatus = false;
					if (
						this.testConfigData.config.timebnsel != "" &&
						this.testConfigData.config.timebnsel != null
					) {
						if (this.testConfigData.config.timebnsel == "hrs") {
							this.testConfigData.config.timebetweenattempts =
								this.testConfigData.config.timebnvalue * 60;
						} else if (this.testConfigData.config.timebnsel == "days") {
							this.testConfigData.config.timebetweenattempts =
								this.testConfigData.config.timebnvalue * 1440;
						} else {
							this.testConfigData.config.timebetweenattempts = this.testConfigData.config.timebnvalue;
						}
					}
					let payload = {
						portion: "Config",
						testID: this.testData.testID,
						name: this.configName,
						groupID: this.selectedGroup.groupID,
						config: this.testConfigData.config,
					};
					const res = await addConfig(payload);
					if (res.status == 200) {
						this.successToast("Configuration added successfully");
						this.$bvModal.hide("confirm-edit");
						this.$bvModal.hide("modal-1");
						let payload = {
							configID: res.data.data.ConfigID,
						};
						this.getConfig(payload);
					} else {
						this.errorToast(res.data.data.Data);
					}
				} else {
					this.errorstatus = true;
				}
			} catch (error) {
				throw new Error(`Failed! Status:${error.status}`);
			}
		},
		goToGroupShare() {
			this.$router.push({
				name: "ShareWithPeopleAutogenerate",
				params: {
					topicID: this.testData.topicID,
					testID: this.testData.testID,
					testName: this.testData.name,
				},
			});
		},
		confirm() {
			this.check = false;
			this.saveConfig();
		},

		moveNextTab() {
			this.$v.$touch();
			if (
				!this.$v.testConfigData.config.testOrg.$invalid &&
				!this.$v.testConfigData.config.testDesc.$invalid &&
				!this.$v.testConfigData.config.testInst.$invalid &&
				!this.$v.testConfigData.config.quesPerScreen.$invalid &&
				!this.$v.testConfigData.config.negativeMarkValue.$invalid &&
				!this.$v.testConfigData.config.testDuration.$invalid &&
				!this.$v.testConfigData.config.screenCapture.$invalid &&
				!this.$v.testConfigData.config.communicationTestAttempts.$invalid
			) {
				this.tabIndex++;
			}
		},
		questionbehaviour() {
			this.$v.testConfigData.config.passingPercentage.$touch();
			this.$v.testConfigData.config.negativeMarkValue.$touch();
			this.$v.testConfigData.config.maxnoattempts.$touch();
			this.$v.testConfigData.config.quesPerScreen.$touch();
			this.$v.testConfigData.config.buffertime.$touch();
			this.$v.testConfigData.config.timebnvalue.$touch();
			this.$v.testConfigData.config.timebnsel.$touch();
			this.$v.testConfigData.config.testDuration.$touch();
			this.$v.testConfigData.config.openTestdt.$touch();
			this.$v.testConfigData.config.closeTestdt.$touch();

			if (
				!this.$v.testConfigData.config.passingPercentage.$invalid &&
				!this.$v.testConfigData.config.negativeMarkValue.$invalid &&
				!this.$v.testConfigData.config.maxnoattempts.$invalid &&
				!this.$v.testConfigData.config.buffertime.$invalid &&
				!this.$v.testConfigData.config.quesPerScreen.$invalid &&
				!this.$v.testConfigData.config.timebnsel.$invalid &&
				!this.$v.testConfigData.config.timebnvalue.$invalid &&
				!this.$v.testConfigData.config.testDuration.$invalid &&
				!this.$v.testConfigData.config.openTestdt.$invalid &&
				!this.$v.testConfigData.config.closeTestdt.$invalid &&
				!this.timeDiffMinutes
			) {
				this.tabIndex++;
			}
		},
		openscreeen() {
			if (this.testinstruction === "not_accepted") {
				this.validateNotAcceptedInstruction();
			}
		},
		validateNotAcceptedInstruction() {
			this.$v.testConfigData.config.testOrg.$touch();
			this.$v.testConfigData.config.testDesc.$touch();
			this.$v.configName.$touch();
			if (
				!this.dirtyCheckDescQuestion &&
				!this.$v.testConfigData.config.testOrg.$invalid &&
				!this.$v.testConfigData.config.testDesc.$invalid &&
				!this.$v.configName.$invalid
			) {
				this.tabIndex++;
			}

			if (
				this.$v.testConfigData.config.testDesc.$invalid ||
				this.dirtyCheckDescQuestion
			) {
				this.dirtyCheckDescQuestion = true;
			}
		},

		systemsetup() {
			this.$v.testConfigData.config.passingPercentage.$touch();
			this.$v.testConfigData.config.screenCapture.$touch();
			this.$v.testConfigData.config.communicationTestDuration.$touch();

			if (
				!this.$v.testConfigData.config.passingPercentage.$invalid &&
				!this.$v.testConfigData.config.screenCapture.$invalid &&
				!this.$v.testConfigData.config.communicationTestDuration.$invalid
			) {
				if (this.testConfigData.config.enableProctoring) {
					if (this.testConfigData.config.enableCamera) {
						this.tabIndex++;
					}
				} else {
					this.tabIndex++;
				}
			}
		},
	},
};
</script>

<style>
/* new style */
.testconfig-saveproceed {
	position: absolute;
	bottom: 10px;
	right: 10px;
}
.topDiv > .vdatetime > input {
	width: 100%;
}
.ptc-dropdown-diffy {
	background: #f4f4f3;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	font-weight: 400;
	font-size: 13px;
	line-height: 20px;
	color: #72738e;
	padding: 6px;
}
.qb-dropdown-option-add {
	background: #ffffff;
	border: 0.2px solid #8a8b8c;
	box-sizing: border-box;
	box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
	border-radius: 5px;
	margin-top: 3px;
	padding: 10px;
	position: absolute;
	z-index: 7;
	width: 100%;
	font-size: var(--size-13);
	color: #545454;
}
.qb-dd-group {
	width: 100%;
	overflow-y: scroll;
}
.qb-add-drop > .btn-secondary:nth-child(2n) {
	background: #fdfdfd;
	color: #545454;
	text-align: left;
	border: none;
}

.qb-add-drop > .btn-secondary:nth-child(2n-1) {
	background: #f4f4f4;
	color: #545454;
	text-align: left;
	border: none;
}
.configlabels {
	font-weight: 400;
	font-size: 14px;

	color: #72738e;
}
.dosdont-addtxt {
	font-weight: 500;
	font-size: 13px;

	text-decoration-line: underline;

	color: #72738e;
}
.b-dropdown-option-arrow:nth-child(even) {
	background: #fdfdfd;
}

.qb-dropdown-option-arrow:nth-child(odd) {
	background: #f4f4f4;
}
.startdateconfig > input {
	font-family: "Poppins", sans-serif;
	border: 0.7px solid rgba(10, 86, 200, 0.5);
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
	border-radius: 3px;
	z-index: 5;
	padding: 5px;
	font-size: var(--size-12);
	background: var(--bg-inputfield);
	color: #6d6d6d;
}

.testconfig-basediv {
	height: calc(100vh - 360px);
	overflow-x: hidden;
	overflow-y: auto;
}

.astc-head {
	font-weight: 400;
	font-size: 13px;
	color: #adaaaa;
}

.astc-border-bottom {
	border: 1px solid #e2e2e2;
}

.testconfigfieldsetStyle {
	color: var(--bg-tertiary);
	background: #f4f4f4;

	position: absolute;
	left: 0.5vw;
	top: -9px;
	font-size: var(--size-10);
	line-height: 18px;
	padding-left: 6px;
	padding-right: 4px;
}
.testconfiginputField {
	background: #f4f4f4;
	border: 1px solid rgba(10, 86, 200, 0.5);

	box-shadow: inset 0px 0px 4px rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	z-index: 5;
	padding-left: 6px;
}
.configpage-checbox
	.custom-checkbox.b-custom-control-sm
	.custom-control-label::before,
.input-group-sm .custom-checkbox .custom-control-label::before {
	width: 15px;
	top: 3px;
	border-radius: 2px;
	height: 15px;
}

.configpage-checbox .custom-control-label {
	color: #72738e;
}
/* new style end */
.eye-margin {
	margin-right: 28.5px !important;
}
.testconfighead-auto {
	font-weight: 600;
	font-size: 14px;
	line-height: 21px;
	margin-top: 2px;
	color: #696969;
}
.tsconfigtext-config-auto {
	font-size: var(--size-13);
	line-height: 19px;
	font-weight: var(--weight-LM);
	line-break: anywhere;
	color: var(--bg-primary);
}

.sidetestconfig .nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
	font-weight: 600;
	font-size: 14px;

	color: #72738e;
}
.sidetestconfig a {
	color: #495057;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
}
.sidetestconfig .sidedatetime input {
	overflow: visible;
	border: 1px solid var(--input-border);
	border-radius: 3px !important;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.375rem 0.75rem;
	font-size: var(--size-12);
	background: var(--bg-inputfield);
	color: #6d6d6d;
	width: 100%;
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
}
.calender-image {
	position: absolute;
	top: 3px;
	right: 5px;
}
.sidetestconfig .nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
	border-color: unset;
}
.sidetestconfig .nav-tabs .nav-link {
	margin-bottom: 1px;
	border: unset;
}
.sidetestconfig a:hover {
	color: #495057;
}
.sidetestconfig .nav-tabs {
	border-bottom: 1px solid #dee2e6;
	justify-content: space-between;
}
.sidetestconfig .nav-link {
	display: block;
	padding: 0.5rem 0rem;
}
.sidetestconfig .nav-tabs .nav-link.active {
	position: relative;
}
.sidetestconfig .nav-tabs .nav-link.active::before {
	content: "";
	height: 5px;
	background-color: #72738e;
	width: 103%;
	position: absolute;
	bottom: -1px;
	border-radius: 5px;
}
.sidetestconfig .tab-pane {
	height: 45vh;
}
</style>
<style scoped>
.input {
	border-left: none;
	border-right: none;
	border-top: none;
	border-radius: 0px;
	margin-right: 2vh;
}
.sidedatetime input {
	overflow: visible;
	border: 1px solid var(--input-border);
	border-radius: 3px !important;
	height: calc(1.5em + 0.75rem + 2px);
	padding: 0.375rem 0.75rem;
	font-size: var(--size-12);
	background: var(--bg-inputfield);
	color: #6d6d6d;
	width: 100%;
	box-shadow: inset 0px 0px 4px rgb(0 0 0 / 25%);
}
.calender-image {
	position: absolute;
	top: 3px;
	right: 5px;
}

.form-control:focus,
.custom-select:focus {
	border-color: inherit;
	-webkit-box-shadow: none;
	box-shadow: none;
}

.btn-danger:focus {
	box-shadow: none !important;
}

.input-group-text {
	border: none;
	background-color: transparent;
}

.rounded-circle {
	border-color: transparent;
	background-color: hsl(0, 0%, 95%);
}

.base {
	width: 100%;
}

.btn:focus,
.btn.focus {
	outline: 0;
	box-shadow: none;
}

.tabclass {
	background: red;
}

.testConText {
	position: fixed;
	top: 230px;
	font-weight: 400;
	color: #707070;
	border-bottom: 1px solid #a2a2a2;
	width: 36%;
	padding: 5px 0px;
	z-index: 3;
	font-size: 18px;
}
.testconfig-attempt {
	font-size: 12px;
	color: var(--bg-tertiary);
}
.testconfig-priority .custom-radio.b-custom-control-sm,
.input-group-sm .custom-radio {
	padding-left: 1.3125rem;
	font-size: var(--size-12) !important;
	color: var(--bg-tertiary);
}

.button-save {
	right: 0;
	position: absolute;
	bottom: 5px;
	padding: 0px 18px;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus {
	box-shadow: none !important;
}

.goToShareLink {
	text-decoration-line: underline;
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
	display: block;
}
.labelforview {
	font-weight: 500;
	font-size: 12px;
	color: #72738e;
	display: block;
}

.astc-left-container-overflow {
	height: calc(100vh - 280px);
	overflow: auto;
}

.astc-group-container {
	background: #f5f5f5;
}

.stc-view-grp-overflow {
	min-height: auto;
	max-height: calc(100vh - 240px);
	overflow: auto;
}

.stc-view-grp-model-cards {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.stc-share-viewgroup-container {
	min-height: auto;
	max-height: calc(100vh - 660px);
	overflow: auto;
}

.stc-view-grp-model-cards-2 {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.stc-view-grp-model-cards-3 {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}

.stc-light-text {
	font-weight: 400;
	font-size: 10px;
	color: #72738e;
}

.stc-model-eval-overflow {
	min-height: auto;
	max-height: calc(100vh - 675px);
	overflow: auto;
}

.astc-config-modal-overflow {
	overflow-x: hidden;
	overflow-y: auto;
	padding-right: 10px;
	height: calc(100vh - 350px);
}
</style>
